module.exports = __webpack_public_path__ + "static/media/icon-hospital.d78d6b61.svg";